/*
 * @Description:
 * @Date: 2024-01-25 10:09:34
 */

import http from '@/utils/http/axios';
import { List } from './types';

const yApi = {
  // yapi: 1263
};

enum Api {
  list = '/front-end/v3/tmpl/api/v1/list', // BI模板列表
  save = '/front-end/v3/tmpl/api/v1/save', // BI模板保存（新增/编辑）
  delete = '/front-end/v3/tmpl/api/v1/delete', // BI模板删除
  get = '/front-end/v3/tmpl/api/v1/get', // BI模板详情
  enable = '/front-end/v3/tmpl/api/v1/enable', // BI模板启用
  relateProjects = '/front-end/v3/tmpl/api/v1/relateProjects', // BI模板-关联项目列表
  customerSelectList = '/front-end/v3/tmpl/api/v1/customerSelectList' // BI模板-关联项目-客户企业下拉列表
}
export const save = async params => {
  const res = await http.request(
    {
      url: Api.save,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );
  return res;
};
export const deleteTel = async params => {
  const res = await http.request(
    {
      url: Api.delete,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );
  return res;
};
export const get = async params => {
  const res = await http.request(
    {
      url: Api.get,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );
  return res;
};
export const list: List = async params => {
  const res = await http.request(
    {
      url: Api.list,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );
  return res;
};
export const enable = async params => {
  const res = await http.request(
    {
      url: Api.enable,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );
  return res;
};
export const relateProjects = async params => {
  const res = await http.request(
    {
      url: Api.relateProjects,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );
  return res;
};
export const customerSelectList = async params => {
  const res = await http.request(
    {
      url: Api.customerSelectList,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );
  return res;
};
